import { render } from "./Footer.vue?vue&type=template&id=ab357c06&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=ab357c06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab357c06"]])

export default __exports__